import { Component, Host, State, h } from '@stencil/core';
import { state } from '../../stores/hamburger';

declare global {
  interface Window {
    getTranslation: any;
  }
}

@Component({
  tag: 'kwo-header',
  shadow: false,
})
export class KwoHeader {
  @State() activeSubNavId: number | null;
  header: HTMLElement;
  buttons: NodeListOf<Element>;
  subnavs: NodeListOf<Element>;
  subnavCloseButton: NodeListOf<Element>;
  hamburger: HTMLElement;

  componentDidLoad() {
    this.header = document.querySelector('.Header');
    this.buttons = document.querySelectorAll('.Header__mainnav button');
    this.subnavs = document.querySelectorAll('.Header__subnav');
    this.subnavCloseButton = document.querySelectorAll('.Header__subnav-closebutton');
    this.hamburger = document.querySelector('.Header__hamburger');
    this.activeSubNavId = null;

    this.subnavCloseButton.forEach(button => {
      button.addEventListener('click', () => this.closeSubMenu());
    });

    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      const currentScrollTop = window.scrollY;

      // change header style on scroll
      if (currentScrollTop > 50) {
        this.header.classList.add('scrolled');
      } else {
        this.header.classList.remove('scrolled');
        this.closeSubMenu();
      }
      // move header to top on scroll
      if (currentScrollTop > 200) {
        this.header.classList.add('hide');
        this.closeSubMenu();
      } else {
        this.header.classList.remove('hide');
      }
      // show header on scroll up
      if (currentScrollTop < lastScrollTop) {
        this.header.classList.remove('hide');
      }
      lastScrollTop = currentScrollTop;
    });
  }

  componentDidUpdate() {
    if (window.getComputedStyle(this.hamburger).display !== 'none' && !state.isOpen) {
      this.closeSubMenu();
    }
    if (state.isOpen) {
      this.header.classList.add('scrolled');
    }
  }

  setActiveSubMenu(e) {
    const clickedButton = e.target.closest('button');
    if (this.activeSubNavId == null) {
      this.buttons.forEach(button => button.classList.remove('collapsed'));
      this.subnavs.forEach(subnav => subnav.classList.remove('open'));
    }

    if (!clickedButton) {
      return;
    }

    if (clickedButton.classList.contains('collapsed')) {
      this.closeSubMenu();
      return;
    }

    this.header.classList.add('scrolled');
    this.buttons.forEach(button => button.classList.remove('collapsed'));
    clickedButton.classList.add('collapsed');
    this.activeSubNavId = clickedButton.dataset.subnav;
    this.subnavs.forEach(subnav => {
      if (subnav.id === `subnav-${this.activeSubNavId}`) {
        subnav.classList.add('open');
      } else {
        subnav.classList.remove('open');
      }
    });
  }

  closeSubMenu() {
    this.activeSubNavId = null;
    this.buttons.forEach(button => button.classList.remove('collapsed'));
    this.subnavs.forEach(subnav => subnav.classList.remove('open'));
    window.scrollY < 50 && this.header.classList.remove('scrolled');
  }

  render() {
    return (
      <Host>
        <div class={`Header__backdrop ${this.activeSubNavId != null ? 'open' : ''}`} onClick={() => this.closeSubMenu()}></div>
        <div class={`Header__wrapper ${this.activeSubNavId == null ? 'transparent' : ''}`}>
          <div class="container-fluid py-md py-xl-ml">
			      <div class="row align-items-center">
				      <div class="col-6 col-lg-3 col-xl-2">
                <slot name="logo" />
              </div>
              <div class="Header__hamburger col d-flex d-xl-none justify-content-end">
                <lg-hamburger></lg-hamburger>
              </div>
              <div class={`Header__mobilenav col d-flex flex-column justify-content-xl-center ${state.isOpen ? 'open' : ''}`}>
                <div class="Header__metanav py-md py-xl-0">
                  <slot name="metanav" />
                </div>
                <div class="Header__mainnav py-lg py-xl-0" onClick={(e)=>this.setActiveSubMenu(e)}>
                  <slot name="navigation" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
